module.exports = __webpack_public_path__ + "img/cengiz.a39255cd.jpg";